import { type LoaderFunctionArgs, json } from '@remix-run/node'
import { useLoaderData } from '@remix-run/react'
import { AspectRatio } from '#app/components/layout/aspect-ratio.tsx'
import { sessionKey } from '#app/utils/auth.server.ts'
import { prisma } from '#app/utils/db.server.ts'
import { authSessionStorage } from '#app/utils/session.server.ts'
import blueSkies from '../images/sarah-lee-ydpczVKWl4w-unsplash.jpg'
import { readSource } from '../sections/sections.server.tsx'
import { Description, Features, Source, type componentProps, Parts, Usage } from '../sections/sections.tsx'

export const handle = {
	breadcrumb: 'AspectRatio',
}

const component: componentProps = {
	name: 'Aspect Ratio',
	shortName: 'AspectRatio',
	fileName: 'aspect-ratio',
	category: 'layout',
	description: ['Displays content within a desired ratio.'],
	features: ['Accepts any custom ratio.'],
	parts: [
		{
			name: 'AspectRatio',
			description: 'Displays content within a desired ratio.',
			props: [{ name: 'ratio', type: 'number', default: '1', description: 'The ratio to display the content within.' }],
		},
	],
	usage: `<AspectRatio ratio={16 / 9}>
	<img src={blueSkies} alt="By Sarah Lee on Unsplash" className="h-full w-full rounded-xl object-cover" />
</AspectRatio>`,
}

export const loader = async ({ request }: LoaderFunctionArgs) => {
	const authSession = await authSessionStorage.getSession(request.headers.get('cookie'))
	const sessionId = authSession.get(sessionKey)
	const session =
		sessionId ?
			await prisma.session.findUnique({
				select: { user: { select: { id: true, paid: true } } },
				where: { id: sessionId, expirationDate: { gt: new Date() } },
			})
		:	null
	const source = session?.user.paid ? await readSource({ category: component.category, fileName: component.fileName }) : null
	return json({ source })
}

const AspectRatioRoute = () => {
	const { source } = useLoaderData<typeof loader>()
	const { name, description, shortName, fileName, features, usage, parts } = component

	return (
		<>
			<Description name={name} description={description} />
			<Features features={features} />
			<Parts parts={parts} />
			<Usage usage={usage} shortName={shortName} />
			<AspectRatio ratio={16 / 9}>
				<img src={blueSkies} alt="By Sarah Lee on Unsplash" className="h-full w-full rounded-xl object-cover" />
			</AspectRatio>
			<Source source={source} fileName={fileName} />
		</>
	)
}
export default AspectRatioRoute
